import { render, staticRenderFns } from "./VideoFormatIcon.vue?vue&type=template&id=7bce9280&scoped=true"
import script from "./VideoFormatIcon.vue?vue&type=script&lang=js"
export * from "./VideoFormatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce9280",
  null
  
)

export default component.exports